import { Navigate } from "react-router-dom";
import ReportScreen from "../features/report/ReportScreen";

const ReportLayout = () => {
  // Report is a super admin screen. The nav tab is already hidden for anyone
  // else, but that alone would not stop someone typing /report in the
  // address bar, so the same isAdmin flag is enforced here too.
  const isSuperAdmin = localStorage.getItem("isAdmin") === "true";

  if (!isSuperAdmin) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="main-container">
      <div className="secondary-container">
        <div className="main-section">
          <ReportScreen />
        </div>
      </div>
    </div>
  );
};

export default ReportLayout;
